import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import CourtInstallation from '@/store/entities/booking/courtInstallation';

interface CourtInstallationState extends ListState<CourtInstallation>{
    editCourtInstallation:CourtInstallation
}
class CourtInstallationMutations extends ListMutations<CourtInstallation>{

}
class CourtInstallationModule extends ListModule<CourtInstallationState,any,CourtInstallation>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<CourtInstallation>(),
        loading:false,
        editCourtInstallation:new CourtInstallation()
    }
    actions={
        async getAll(context:ActionContext<CourtInstallationState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/CourtInstallation/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<CourtInstallation>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<CourtInstallationState,any>,payload:any){
            await Ajax.post('/api/services/app/CourtInstallation/Create',payload.data);
        },
        async update(context:ActionContext<CourtInstallationState,any>,payload:any){
            await Ajax.put('/api/services/app/CourtInstallation/Update',payload.data);
        },
        async delete(context:ActionContext<CourtInstallationState,any>,payload:any){
            await Ajax.delete('/api/services/app/CourtInstallation/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<CourtInstallationState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/CourtInstallation/Get?Id='+payload.id);
            return reponse.data.result as CourtInstallation;
        }
    };
    mutations={
        setCurrentPage(state:CourtInstallationState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:CourtInstallationState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:CourtInstallationState,courtInstallation:CourtInstallation){
            state.editCourtInstallation=courtInstallation;
        }
    }
}
const courtInstallationModule=new CourtInstallationModule();
export default courtInstallationModule;